<template>
  <section class="layout-pt-lg layout-pb-lg" :style="`background-color: var(--c-${vars.backgroundColor})`">
    <div class="container">
      <div v-if="vars.titleHtml" class="tw-mb-8 tw-w-full tw-text-center lg:tw-mb-12">
        <div v-if="vars.titleHtml" v-html="vars.titleHtml"></div>
      </div>

      <div class="relative">
        <div
          class="absoluteNavSlider overflow-hidden js-section-slider"
          data-gap="30"
          data-slider-cols="xl-2 lg-2 md-2 sm-2 base-1"
          data-nav-prev="js-cardsSlider-prev"
          data-nav-next="js-cardsSlider-next"
        >
          <div class="swiper-wrapper">
            <div class="swiper-slide !tw-h-full" v-for="(card, index) in cards" :key="index">
              <library-iframe v-if="card.video" :src="card.video" :h-ratio="9" :w-ratio="16" />
              <library-image v-else-if="card.photo" :src="card.photo" :h-ratio="9" :w-ratio="16"></library-image>
              <div v-if="card.title" class="tw-mt-4 tw-flex tw-flex-col tw-gap-3">
                <h5 v-if="card.title">{{ card.title }}</h5>
                <p v-if="card.description">{{ card.description }}</p>
              </div>
            </div>
          </div>
        </div>

        <div class="absoluteNav">
          <button class="sliderNav -prev js-cardsSlider-prev">
            <i class="icon-left-arrow"></i>
          </button>
          <button class="sliderNav -next ml-20 js-cardsSlider-next">
            <i class="icon-right-arrow"></i>
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'VideoBox',
  mixins: [ComponentMixin],
  computed: {
    descriptions() {
      return this.groupedVariables.descriptions;
    },
    cards() {
      return this.groupedVariables.cards;
    },
  },
});
</script>

<style scoped>
::v-deep iframe {
  z-index: 10 !important;
}

.absoluteNav {
  pointer-events: none;
}

.absoluteNav .sliderNav {
  pointer-events: auto;
  z-index: 15 !important;
  transition: opacity 0.3s ease;
}

.absoluteNav .sliderNav.swiper-button-disabled {
  opacity: 0.3;
}

/* Swiper'ın otomatik disabled class'ı yoksa manuel kontrol için */
.absoluteNav .sliderNav:disabled {
  opacity: 0.3;
}
</style>
